var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3769 83.3116H21.804L27.27 77.8456L13.1545 63.73L7.68845 69.196V75.6231H15.3769V83.3116ZM52.798 28.5914C53.0783 28.3111 53.2185 27.9707 53.2185 27.5703C53.2185 26.6893 52.778 26.2488 51.897 26.2488C51.4966 26.2488 51.1562 26.389 50.8759 26.6693L18.3201 59.2251C18.0398 59.5054 17.8997 59.8458 17.8997 60.2462C17.8997 61.1272 18.3402 61.5677 19.2211 61.5677C19.6216 61.5677 19.9619 61.4275 20.2422 61.1472L52.798 28.5914ZM0 66.0125L49.9749 16.0376L74.9624 41.0251L24.9875 91H0V66.0125ZM88.7776 16.338C90.2592 17.8997 91 19.7217 91 21.804C91 23.9263 90.2592 25.7283 88.7776 27.2099L78.8066 37.1809L53.8191 12.1934L63.7901 2.28251C65.2317 0.760836 67.0337 0 69.196 0C71.3184 0 73.1404 0.760836 74.662 2.28251L88.7776 16.338Z",
    fill: "#D7D7D7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 91,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteEdit);
export default __webpack_public_path__ + "static/media/whiteEdit.29d6da4f88192389cee7932c5d478925.svg";
export { ForwardRef as ReactComponent };